import { api, storage } from './api';
import type { Profile } from './types';

export function detectDevice() {
  const ua = navigator.userAgent;
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  let platform = 'UNKNOWN';
  if (/Android/i.test(ua)) platform = 'ANDROID';
  else if (/iPhone|iPad|iPod/i.test(ua)) platform = 'IOS';
  else if (/Macintosh|Mac OS X/i.test(ua)) platform = 'MACOS';
  else if (/Windows/i.test(ua)) platform = 'WINDOWS';
  else if (/Linux/i.test(ua)) platform = 'LINUX';

  const browser = /Edg\//.test(ua) ? 'Edge' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : /Firefox\//.test(ua) ? 'Firefox' : 'Browser';
  return {
    type: mobile ? 'PHONE' as const : 'LAPTOP' as const,
    // A browser session, however it is dressed up by the user agent.
    kind: 'PWA' as const,
    platform,
    name: mobile ? `${browser} phone` : `${browser} on ${platform === 'UNKNOWN' ? 'computer' : platform.toLowerCase()}`
  };
}

export async function ensureBrowserDevice(profile: Profile) {
  const currentId = storage.deviceId;
  if (currentId && profile.devices.some(device => device.id === currentId)) return currentId;

  const detected = detectDevice();
  const created = await api<{ id: string }>('/devices/register', {
    method: 'POST',
    body: JSON.stringify({ ...detected, installationId: storage.installationId })
  });
  storage.deviceId = created.id;
  return created.id;
}

export async function heartbeat(deviceId: string) {
  const connection = (navigator as Navigator & { connection?: { effectiveType?: string; type?: string } }).connection;
  await api(`/devices/${deviceId}/heartbeat`, {
    method: 'POST',
    body: JSON.stringify({ network: connection?.effectiveType || connection?.type || (navigator.onLine ? 'online' : 'offline') })
  });
}
